<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UcTD1T/tc-custom/9781614481911.jpg?1704717788434" alt="This image is the cover for the book Power to Stop Any Out-of-Control Behavior in 30 Days"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Power to Stop Any Out-of-Control Behavior in 30 Days
      </h1>
      <p class="bookDescription body article font2">
        <p>LOVE IS THE SOLUTION! The Power to Stop is a 30-day do-it-yourself spiritual recovery training program that teaches how to stop out-of-control behaviors, bad habits or substance abuse problems. The secret of success is the experience of self-love, which is learned through four practical, easy stopping skills. The Power to Stop accelerates personal growth, restores connection with God and renews deep, rich meaning in life. Take the happy leap from wasting your life to saving it with love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Bentley
      </h2>
      
      <p class="authorDescription body article">Karen “Big Heart” Bentley is an expert in using the practical power of love to solve problems, especially stopping problems. Wanting to stop is the hardest part, and Bentley delivers the inspiration to stop in spades.   As the world’s only self-proclaimed stopping Sherpa, Bentley serves as a one-of-a-kind guide who makes stopping doable and desirable for others.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?67c1231c